var _style, _path, _polygon, _path2, _path3, _path4, _path5, _rect, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 75.76",
    style: {
      enableBackground: "new 0 0 400 75.76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#170F42;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.31,24.58v42.62c13.05-14.2,26.1-28.4,39.15-42.61l0.18,42.35c12.97-14.12,25.95-28.24,38.92-42.37"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "142.13,24.58 151.51,51.68 161.3,24.58 174.65,24.58 157.74,67.22 145.85,67.22 136.06,40.2  126.27,67.22 114.38,67.22 97.47,24.58 111.39,24.58 121.25,51.68 130.64,24.58 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.4,9.13h12.94v20.63c3.32-3.48,8.66-6.07,15.53-6.07c11.08,0,18.61,7.44,18.61,19.25v24.27h-12.94V46.75 c0-7.2-3.48-11.57-10.11-11.57c-7.04,0-11.09,4.29-11.09,11.65v20.39H177.4V9.13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.85,9.13h13.19v11.08h-13.19V9.13z M244.87,67.22h-12.94V24.58h12.94V67.22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.28,8.24c3.96,0,8.09,0.57,10.68,1.54l-1.7,10.11c-2.67-0.73-5.18-1.13-8.17-1.13 c-5.5,0-8.09,1.62-8.09,5.42v0.4h15.69v10.68H271v31.95h-12.78V35.26h-9.63V24.58h9.63v-0.65C258.22,13.34,265.66,8.24,278.28,8.24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.94,8.24c3.96,0,8.09,0.57,10.68,1.54l-1.7,10.11c-2.67-0.73-5.18-1.13-8.17-1.13 c-5.5,0-8.09,1.62-8.09,5.42v0.4h15.69v10.68h-15.69v31.95h-12.78V35.26h-9.63V24.58h9.63v-0.65 C291.87,13.34,299.32,8.24,311.94,8.24"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 325.29,
    y: 9.13,
    className: "st0",
    width: 12.94,
    height: 58.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.67,51.12l11.41,4.13c-3.07,7.52-12.22,12.86-23.38,12.86c-15.13,0-25.73-8.98-25.73-22.25 c0-12.62,10.6-22.17,25.64-22.17c15.29,0,24.19,9.87,24.19,22v3.56H356.6c1.46,5.42,6.39,8.58,13.02,8.58 C375.28,57.83,379.81,55.24,381.67,51.12 M356.92,41.33h23.87c-0.57-3.56-4.77-7.6-11.57-7.6C363.55,33.73,358.7,36.31,356.92,41.33 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a4208b6fb4c658df7aab38ee155c96c.svg";
export { ForwardRef as ReactComponent };